import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MainButton from './MainButton';
import styled from 'styled-components';
import { translate } from 'react-polyglot';
import media from './MediaQueries';

const StyledQuestions = styled.div`
  position: absolute;
  right: 0; left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  max-width: 440px;
  width: 100%;
  max-height: 400px;

  ${media.phone`
    max-width: auto;
    max-height: auto;
    padding: 0 30px;
    top: 10%;
    bottom: auto;
  `}

  .title {
    color: white;
    font-size: 36px;
    font-weight: 100;

    ${media.phone`
      font-size: 24px;
      font-weight: 300;
    `}
  }

  .buttonsContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 3vh;
  }
`

class Questions extends Component {
  render = () => {
    const { title, choices, multiSelect, iconColors, buttonTextAlign, autoAdvance, inRequestProperty } = this.props.options; // from backend
    const { t, filters, toggleFilter, nextPage } = this.props;  // internal

    return (
      <StyledQuestions className="questions">
        <h2 className="title">{title}</h2>
        <div className="buttonsContainer">
          {
            choices.map((oKey, i) => {
              let key, value, label;

              // Find out of this choice is selected or not
              var selected = false;

              // if the choice is object, it means key shall be key in filter
              // and choise object value will act as the value of filter.
              if (typeof oKey === 'object') {
                key = Object.keys(oKey)[0];
                value = oKey[key];
                label = t(value.replace('_ui', ''));
              } else {

                // if the choise is a string, the key will key and 
                // value will be 1. Simple 'boolean' API filter.
                key = oKey;
                value = 1;
                label = t(key.replace('_ui', ''));
              }

              // This allows to insert the value into a different root of the
              // request object.
              if (inRequestProperty) {
                if (filters.hasOwnProperty(inRequestProperty)) {
                  selected = filters[inRequestProperty][key] === value;
                }
              } else {
                selected = filters[key] === value;
              }

              let icon;
              if (iconColors && iconColors.length > i) {
                icon = {
                  color: iconColors[i]
                }
              }

              return <MainButton
                  key={key+'/'+i}
                  selected={selected}
                  onClick={() => {
                    toggleFilter(key, selected ? 0 : value, choices, multiSelect, autoAdvance, nextPage, inRequestProperty);
                  }}
                  align={buttonTextAlign}
                  icon={icon}
                >
                {label}
              </MainButton>
            })
          }
        </div>
      </StyledQuestions>
    )
  }
}

Questions.propTypes = {
  options: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    choices: PropTypes.array,
    buttonTextAlign: PropTypes.string,
    autoAdvance: PropTypes.bool
  })
}

export default translate()(Questions);



// WEBPACK FOOTER //
// ./src/components/instore/Questions.js